import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
  BasePageMetaResolver,
  Category,
  PageDescriptionResolver,
  PageMetaResolver,
  PageRobotsMeta,
  PageRobotsResolver,
  PageTitleResolver,
  PageType
} from '@spartacus/core';
import { filter, Observable, of, switchMap } from 'rxjs';
import { getAllFamiliesListState } from 'src/app/custom/cms-components/families/custom-families/store/selectors/custom-families.selectors';


/**
 * Resolves the page data for the Families Listing Page.
 *
 */
@Injectable({
  providedIn: 'root',
})
export class CustomFamiliesPageMetaResolver
  extends PageMetaResolver
  implements PageTitleResolver,
  PageDescriptionResolver,
  PageRobotsResolver {

  constructor(
    protected store: Store,
    protected basePageMetaResolver: BasePageMetaResolver,
  ) {
    super();
    this.pageType = PageType.CONTENT_PAGE;
    this.pageTemplate = 'LandingPage4Template';
  }

  resolveTitle(): Observable<string> {

    return this.store.pipe(
      select(getAllFamiliesListState),
      filter((cat: any) => !!cat),
      switchMap((cat: Category) => {
        const dameroMetaTitle = cat.dameroMetaTitle;
        let title: string;
        if (dameroMetaTitle) {
          title = dameroMetaTitle;
        } else {
          title = cat.name;
        }
        return of(title);
      })
    );
  }

  resolveDescription(): Observable<string> {
    return this.store.pipe(
      select(getAllFamiliesListState),
      filter((cat: any) => !!cat),
      switchMap((cat: Category) => {
        let description = cat.dameroMetaDescription;
        if (description === '$longDescription') {
          description = cat.familyText;
        }
        description = description?.replace(/(&nbsp;)/g, '');
        description = description?.replace(/(\r\n|\n|\r)/gm, '');
        return of(description?.replace(/<\/?[^>]+(>|$)/g, "").substring(0, 150));
      })
    );
  }

  resolveRobots(): Observable<PageRobotsMeta[]> {
    return this.basePageMetaResolver.resolveRobots();
  }
}
